export default __webpack_public_path__ + "static/media/029-woodworking.49a2660b.png";